import { useTranslation } from "react-i18next";
import { BadgeAlert, Percent, Wallet, CalendarRange } from "lucide-react";
import { Field } from "../../../components/neu/Field";
import { Toggle } from "./Toggle";

// تبويب السلف في إعدادات الفرع: تشغيل/إيقاف السلف، النسبة، السقف، وأقصى أشهر السداد.
export const AdvanceTab = ({ form, setNested }) => {
  const { t } = useTranslation();
  const p = form.payroll;
  const on = !!p.advances_allowed;

  return (
    <div className="grid gap-5">
      <div className="rounded-2xl p-4 shadow-neu-in">
        <Toggle
          label={t("branches.advancesAllowed")} testId="branch-advances_allowed"
          value={on} onChange={(v) => setNested("payroll", "advances_allowed", v)}
        />
        <p className="mt-3 flex items-start gap-2 text-xs text-muted-foreground" data-testid="branch-advances-hint">
          <BadgeAlert className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
          {on ? t("branches.advancesOnHint") : t("branches.advancesOffHint")}
        </p>
      </div>

      <div className="relative">
        <div className={`grid gap-5 sm:grid-cols-3 ${on ? "" : "pointer-events-none opacity-40 blur-[1px]"}`}>
          <Field
            label={t("branches.advancePercent")} testId="branch-advance_max_percent" type="number" min="0" max="100"
            value={p.advance_max_percent} onChange={(v) => setNested("payroll", "advance_max_percent", v)}
            accent="emerald" icon={Percent}
          />
          <Field
            label={t("branches.advanceMax", { currency: p.currency })} testId="branch-advance_max_amount" type="number" min="0"
            value={p.advance_max_amount ?? ""} onChange={(v) => setNested("payroll", "advance_max_amount", v)}
            accent="amber" icon={Wallet}
          />
          <Field
            label={t("branches.advanceMonths")} testId="branch-advance_max_repayment_months" type="number" min="1" max="24"
            value={p.advance_max_repayment_months ?? 6} onChange={(v) => setNested("payroll", "advance_max_repayment_months", v)}
            accent="cyan" icon={CalendarRange}
          />
        </div>

        {!on ? (
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center"
            data-testid="branch-advances-watermark">
            <p className="-rotate-12 select-none text-2xl font-black uppercase tracking-widest text-destructive/40">
              {t("branches.advancesStopped")}
            </p>
          </div>
        ) : null}
      </div>

      <p className="text-xs text-muted-foreground">
        {t("branches.advanceExample", {
          percent: p.advance_max_percent || 0,
          months: p.advance_max_repayment_months || 1,
        })}
      </p>
    </div>
  );
};
